import React from 'react';
import { Row, Col, Card } from 'react-bootstrap';

const MessageStatsCards = ({ stats }) => {
  const statsConfig = [
    {
      title: 'إجمالي الرسائل',
      value: stats.total || 0,
      icon: 'bi-envelope',
      color: 'primary',
      bgColor: 'rgba(71, 19, 150, 0.1)'
    },
    {
      title: 'قيد الانتظار',
      value: stats.pending || 0,
      icon: 'bi-clock',
      color: 'warning',
      bgColor: 'rgba(255, 198, 0, 0.1)'
    },
    {
      title: 'تم الإرسال',
      value: stats.sent || 0,
      icon: 'bi-check-circle',
      color: 'success',
      bgColor: 'rgba(40, 167, 69, 0.1)'
    },
    {
      title: 'فشل',
      value: stats.failed || 0,
      icon: 'bi-x-circle',
      color: 'danger',
      bgColor: 'rgba(220, 53, 69, 0.1)'
    }
  ];

  return (
    <Row className="mb-4" dir="rtl">
      {statsConfig.map((stat, index) => (
        <Col key={index} xs={12} sm={6} lg={3} className="mb-3">
          <Card className="h-100 border-0 shadow-sm">
            <Card.Body>
              <div className="d-flex align-items-center">
                <div
                  className="rounded-circle p-3 me-3"
                  style={{ backgroundColor: stat.bgColor }}
                >
                  <i
                    className={`${stat.icon} text-${stat.color}`}
                    style={{ fontSize: '1.5rem' }}
                  ></i>
                </div>
                <div>
                  <p className="text-muted mb-1 small">{stat.title}</p>
                  <h3 className="mb-0 fw-bold">{stat.value.toLocaleString('ar-SA')}</h3>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default MessageStatsCards;
